import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import List from 'yoda-core-components/lib/components/List/List';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from '../SpecialOffers/SpecialOffers.css';
import cartService from '../../services/CartService';

const cx = classNames.bind(styles);

export class BestCouponModal extends Component {
    static propTypes = {
        closeModal: PropTypes.bool.isRequired,
        bestCouponDetails: PropTypes.arrayOf(PropTypes.object),
        isModalOpen: PropTypes.bool,
    };

    static defaultProps = {
        bestCouponDetails: [],
        isModalOpen: false,
    };

    renderCouponDetailsContent = (dataItem) => {
        // get the appropriate value for Modal
        const couponModalInfo = cartService.getCouponModalInfo(dataItem);
        const {
            redeemingChannel,
            offerItems,
            headLineText,
            description,
            conjunction,
            expiryDate,
        } = couponModalInfo;

        let headLine = '';
        // classes
        const conjuntionClasses = `${cx('conjunctionline')} ${dt([
            'text-center',
            'text-small',
            'my-4',
            'text-gray-60',
            'border-b',
            'border-gray-70',
            'border-solid',
            'sm:leading-[1.6px]',
        ])}`;
        const headLineClasses = `${cx('couponHeadline')} ${dt([
            'text-xlarge',
            'leading-6',
            'mb-2',
        ])}`;
        const couponDetailsClasses = `${cx('couponDetailsBlock')}
            ${dt(['font-open-sans-bold', 'text-left', 'p-0'])}`;
        const couponValidityClasses = dt([
            'border-dashed',
            'border-gray-40',
            'border-2',
            'rounded-small',
            'text-small',
            'p-2',
            'm-auto',
            'my-2',
        ]);
        if (offerItems.length === 1) {
            headLine = (
                <div>
                    {' '}
                    <p className={headLineClasses}> {headLineText} </p>
                    <p className={cx('couponBody')}> {description} </p>
                </div>
            );
        } else {
            headLine = (
                <div>
                    {' '}
                    <p className={headLineClasses}> {headLineText} </p>
                    <p className={cx('couponBody')}> {description} </p>
                    <p className={conjuntionClasses}>
                        {' '}
                        <span className={dt(['bg-white', 'px-2'])}>{conjunction} </span>
                    </p>
                    <p className={headLineClasses}>
                        {' '}
                        {get(dataItem, 'offers[0].data[1].name', '')}{' '}
                    </p>
                    <p className={cx('couponBody')}>
                        {' '}
                        {get(dataItem, 'offers[0].data[1].description', '')}{' '}
                    </p>
                </div>
            );
        }

        const couponValidity = (
            <div className={couponValidityClasses}>
                <p>
                    {' '}
                    <span className={dt(['font-open-sans-semibold'])}> Code: </span>{' '}
                    <span> {dataItem.name} </span>{' '}
                </p>
                <p>
                    {' '}
                    <span className={dt(['font-open-sans-semibold'])}> Expires: </span>{' '}
                    <span> {expiryDate} </span>{' '}
                </p>
            </div>
        );
        /* istanbul ignore next */
        return (
            <div>
                <div>
                    <div
                        className={couponDetailsClasses}
                        data-automation-id="couponDetailsContainer"
                    >
                        <div
                            className={`${cx('couponHeaderBlock')} ${dt([
                                'w-2/3',
                                'px-2',
                                'md:inline-block',
                                'smOnly:w-full',
                            ])}`}
                        >
                            <p
                                className={`${cx('redeemingChannel')} ${dt([
                                    'text-gray-60',
                                    'mb-2',
                                ])}`}
                            >
                                {redeemingChannel.toUpperCase()}
                            </p>
                            {headLine}
                        </div>
                        <div
                            className={`${cx('couponValidityBlock')} ${dt([
                                'inline-flex',
                                'md:inline-block',
                                'w-1/3',
                                'align-top',
                                'px-2',
                                'smOnly:w-full',
                            ])}`}
                        >
                            {couponValidity}
                        </div>
                    </div>
                    <p className={dt(['mt-2', 'text-left'])}>{dataItem.disclaimerText}</p>
                </div>
                <p className={`${cx('disclaimerTemplate')} ${dt(['mt-2', 'text-left'])}`}>
                    {' '}
                    {dataItem.disclaimerText}{' '}
                </p>
            </div>
        );
    };

    render() {
        const { bestCouponDetails, isModalOpen, closeModal } = this.props;

        return (
            <ModalBox
                showModal={isModalOpen}
                onClose={closeModal}
                defaultHeader
                automationId="couponDetails-modal"
                modalTheme={`${cx('couponModalWrapper')} ${dt([
                    'smOnly:!w-[90%]',
                    '!max-h-[none]',
                ])}`}
                modalBlockTheme={`${cx('couponPriceModal')} ${dt(['overflow-hidden'])}`}
            >
                <List
                    childRenderer={this.renderCouponDetailsContent}
                    datasource={bestCouponDetails}
                    direction="Vertical"
                    automationId="couponDetails-List"
                />
            </ModalBox>
        );
    }
}

export default BestCouponModal;
